import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useMemo } from 'react';
import isEqualWith from 'lodash/isEqualWith';
import { useSelector, useDispatch } from 'react-redux';
import { DuperbrowseStreamContext } from './DuperbrowseStreamContext';
import { getLastViewedItem } from '../redux/selectors';
import { loadDuperbrowse } from '../redux/actionCreators';
import { useDeepEqualCustomMemo } from '../../utils/hooks/useDeepEqualMemo';
import { getDeviationEntityId } from '../../redux/normalizr/schemas/deviation';
const DuperbrowseStreamContextProvider = ({ children, stream })=>{
    const lastViewedItem = useSelector(getLastViewedItem);
    const dispatch = useDispatch();
    const memodStream = useDeepEqualCustomMemo(stream, (a, b)=>{
        var _a_items_, _a_items, _b_items_, _b_items;
        // use default comparison for loadable and normalized streams
        if (!(a === null || a === void 0 ? void 0 : (_a_items = a.items) === null || _a_items === void 0 ? void 0 : (_a_items_ = _a_items[0]) === null || _a_items_ === void 0 ? void 0 : _a_items_.hasOwnProperty('deviationId')) || !(b === null || b === void 0 ? void 0 : (_b_items = b.items) === null || _b_items === void 0 ? void 0 : (_b_items_ = _b_items[0]) === null || _b_items_ === void 0 ? void 0 : _b_items_.hasOwnProperty('deviationId'))) {
            return undefined;
        }
        const { items: aItems } = a, aWithoutItems = _object_without_properties(a, [
            "items"
        ]);
        const { items: bItems } = b, bWithoutItems = _object_without_properties(b, [
            "items"
        ]);
        if (!isEqualWith(aWithoutItems, bWithoutItems)) {
            return false;
        }
        return isEqualWith(aItems, bItems, (aItem, bItem)=>getDeviationEntityId(aItem) === getDeviationEntityId(bItem));
    });
    const contextProps = useMemo(()=>({
            stream: memodStream,
            lastViewedItem,
            loadDuperbrowse: (itemId, streamId)=>dispatch(loadDuperbrowse(itemId, streamId))
        }), [
        dispatch,
        lastViewedItem,
        memodStream
    ]);
    return /*#__PURE__*/ React.createElement(DuperbrowseStreamContext.Provider, {
        value: contextProps
    }, children);
};
DuperbrowseStreamContextProvider.displayName = 'DuperbrowseStreamContextProvider';
export default DuperbrowseStreamContextProvider;
